import React, { useState, useEffect } from "react";
import Cookies from "js-cookie";
import "../css/css_pages/Dashboard.css";
import "../css/css_layouts/Table.css";
import "../css/css_pages/Button.css";
import config from "../../config";
import { useNavigate } from "react-router-dom";

const ManagementDashboard = () => {
  const token = Cookies.get("authToken");
  const navigate = useNavigate();
  const [tsoDataList, setTsoDataList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchQuery, setSearchQuery] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const itemsPerPage = 10;

  const startYear = 2023;
  const currentYear = new Date().getFullYear();
  const years = Array.from(
    { length: currentYear - startYear + 1 },
    (_, i) => (startYear + i).toString()
  );

  const totalColumns = 13 + (years.length * 3);

  const fetchTSOList = async () => {
    setIsLoading(true);
    try {
      const response = await fetch(
        `${config.API_URL}/management/tso-management-data`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      const data = await response.json();
      console.log("API Response:", data);
      if (Array.isArray(data)) {
        setTsoDataList(data);
      } else {
        console.error("API response is not an array:", data);
      }
    } catch (error) {
      console.error("Error fetching TSO list:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchTSOList();
  }, []);

  const filteredData = tsoDataList.filter((tso) => {
    return tso.tsoDetails && typeof tso.tsoDetails === 'string'
      ? tso.tsoDetails.toLowerCase().includes(searchQuery.toLowerCase())
      : false;
  });

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  return (
    <>
      <h1 style={{ textAlign: "center" }}>Management Dashboard</h1>
      {/* <button className="btn-primary" onClick={() => navigate("/service-progress-form")}>
          Service Progress Form
      </button> */}
      <br/>
      <input
        type="text"
        placeholder="Search by TSO Name"
        value={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
        style={{ marginTop: "20px", marginBottom: "20px", padding: "10px", width: "300px", borderRadius: "10px", border: "2px solid gray" }}
      />

      <div className="management-table-wrapper">
        <div className="table-container">
          <table className="dashboard-table">
            <thead>
              <tr>
                <th rowSpan="2">TSO Name</th>
                <th colSpan="3">Progress for the Date</th>
                <th rowSpan="2">No of Clients</th>
                <th colSpan="4">Service</th>
                <th colSpan="4">Feedback</th>
                {years.map(year => (
                  <th key={year} colSpan="3">{year}</th>
                ))}
              </tr>
              <tr>
                <th>Service %</th>
                <th>Monthly Collection %</th>
                <th>Overall collection %</th>
                <th>Visits</th>
                <th>Online</th>
                <th>Total</th>
                <th>Report Received</th>
                <th>Best</th>
                <th>Good</th>
                <th>Avg</th>
                <th>Bad</th>
                {years.map(year => (
                  <React.Fragment key={year}>
                    <th>Due</th>
                    <th>Collection</th>
                    <th>Balance</th>
                  </React.Fragment>
                ))}
              </tr>
            </thead>
            <tbody>
              {isLoading ? (
                <tr>
                  <td colSpan="22" style={{ textAlign: "center" }}>Loading...</td>
                </tr>
              ) : currentItems.length > 0 ? (
                currentItems.map((tso, index) => {
                  const serviceData = tso.tsoServiceData[0] || {};
                  const feedbackData = tso.tsoFeedbackData[0] || {};

                  return (
                    <tr key={index}>
                      <td>{tso.tsoDetails || "-"}</td>
                      <td>{serviceData.servicePercentage || "-"}</td>
                      <td>{serviceData.monthlyCollectionPercentage || "-"}</td>
                      <td>{serviceData.overallCollectionPercentage || "-"}</td>
                      <td>{serviceData.clients || "-"}</td>
                      <td>{serviceData.visits !== undefined ? serviceData.visits : "-"}</td>
                      <td>{serviceData.online !== undefined ? serviceData.online : "-"}</td>
                      <td>{serviceData.total !== undefined ? serviceData.total : "-"}</td>
                      <td>{serviceData.reports !== undefined ? serviceData.reports : "-"}</td>
                      <td>{feedbackData.best !== undefined ? feedbackData.best : "-"}</td>
                      <td>{feedbackData.good !== undefined ? feedbackData.good : "-"}</td>
                      <td>{feedbackData.average !== undefined ? feedbackData.average : "-"}</td>
                      <td>{feedbackData.bad !== undefined ? feedbackData.bad : "-"}</td>
                      {years.map(year => {
                        const yearData = tso.tsoCollectionData[year]?.[0] || {};
                        return (
                          <React.Fragment key={year}>
                            <td>{yearData.due ?? "-"}</td>
                            <td>{yearData.collection ?? "-"}</td>
                            <td>{yearData.balance ?? "-"}</td>
                          </React.Fragment>
                        );
                      })}
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td colSpan="22" style={{ textAlign: "center" }}>No data available</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
      <br />

      <div className="pagination-buttons">
        {Array.from(
          { length: Math.ceil(filteredData.length / itemsPerPage) },
          (_, i) => (
            <button
              key={i}
              onClick={() => paginate(i + 1)}
              disabled={i + 1 === currentPage}
              className={i + 1 === currentPage ? "active" : "btn-primary"}
            >
              {i + 1}
            </button>
          )
        )}
      </div>
    </>
  );
};

export default ManagementDashboard;
